import React from 'react'
import Logo from '../Logo'

export default function Header({title}) {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
    <Logo className="h-20 w-24"/>
    <h2 className="mt-4 mb-4 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
     {title}
    </h2>
  </div>
  )
}
